<template>

    <div class="dd-facebook-sign">
        <vue-ladda button-class="dd-m-button dd-m-button--default dd-m-button--assertive"
                   v-on:click="checkIfUserIsConnected()"
                   :loading="loading">
            Entrar com o Facebook
        </vue-ladda>

        <div class="dd-m-alert dd-m-alert--danger dd-m-m-t-12" v-if="errors.length && !loading">
            <span v-for="(item, index) in errors" :key="index">
                {{item}}
            </span>
        </div>
    </div>

</template>
<script>
    import AuthService from '../providers/api/auth-service';

    const api = new AuthService();

    export default {
        name: 'facebook-sign',
        data: () => {
            return {
                accessToken: null,
                loading: false,
                errors: []
            }
        },
        mounted() {
        },
        methods: {
            checkIfUserIsConnected() {
                this.loading = true;
                FB.getLoginStatus((response) => {
                    if (response.status === 'connected') {
                        this.accessToken = response.authResponse.accessToken;
                        localStorage.accessToken = this.accessToken;
                        this.sign();
                    } else {
                        this.signFB();
                    }
                });
            },
            updateLocalStorage(token) {
                localStorage.token = token;
                PubSub.publish('updatedSign');
                PubSub.publish('closeLoginModal');
            },
            sign() {
                this.errors = [];
                api.doSignFacebook(this.accessToken)
                    .then((res) => {
                        this.updateLocalStorage(res.data.data.token);
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.errors = [err.response.data.error.message];
                        this.loading = false;
                    });
            },
            signFB() {
                if (this.accessToken) {
                    this.sign();
                } else {
                    FB.login((response) => {
                        if (response.authResponse) {
                            this.accessToken = response.authResponse.accessToken;
                            localStorage.accessToken = this.accessToken;
                            this.sign();
                        } else {
                            this.loading = false;
                        }
                    }, {scope: 'email'});
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/facebook-sign.vue